import React from 'react'
import PropTypes from 'prop-types'

import FilterButton from './filter-button'

function CategoryList({ terms }) {
  if (terms.length > 0) {
    return (
      <>
        {terms.map(term => (
          <FilterButton term={term} key={term.term_id} />
        ))}
      </>
    )
  }

  return null
}

CategoryList.propTypes = {
  terms: PropTypes.array.isRequired,
}

export default CategoryList
